import swal from "sweetalert2";
import AdminApi from "../../services/api";
import session from "../../services/session";


const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            role: '',
            notifications: []
        }
    },
    methods: {
        getNotifications: getNotifications,
        deleteNotification: deleteNotification,
        getStyle: getStyle,
        isLink: isLink,
        detectAgent: detectAgent,
        close: close,
        isSimpleText: isSimpleText,
        onButtonClicked: onButtonClicked,
        getButtonText: getButtonText,
        isButton: isButton,
        moreInfo: moreInfo,
        contact: contact,
        reserve: reserve,
        openTerms:openTerms
    },
    beforeMount() {
        this.role = session.getRole();
        this.getNotifications()
        //TODO dodati kad se uploaduju aplikacije
        // this.detectAgent()
    }
}

function detectAgent() {
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: 'Preuzmi aplikaciju klikom na ikonicu',
            html : '<html><div class="foo">' +
                '<br>' +
                '<a href="https://play.google.com/store/apps/details?id=com.crossfitns.rs">' +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ne sada',
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: 'Preuzmi aplikaciju klikom na ikonicu',
            html : '<html><div class="foo">' +
                '<br>' +
                '<a href="itms-apps://itunes.apple.com/app/id1477340738">' +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ne sada',
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}

function close() {
    swal.close()
}

function getNotifications() {
    // var gym = localStorage.getItem('GYM')
    // if(gym == null || gym === null){
    //     gym = 'gaainzfactory'
    // }
    // AdminApiService.getNotification(gym)
    //     .then((response) => {
    //         this.notifications = response.data
    //     })
    //     .catch(error => {
    //         swal('Greška', error.data.localized_error_message, 'error')
    //     })
}

function getStyle(notification) {
    if(notification.priority === 'LOW'){
        return "color: white; font-size: 20px;"
    }else if(notification.priority === 'MEDIUM'){
        return "color: orange; font-size: 20px;"
    } else if(notification.priority === 'HIGH'){
        return "color: red; font-size: 20px;"
    }
}

function deleteNotification(notification) {
    AdminApiService.deleteNotifications(notification.id)
        .then((response) => {
            this.getNotifications()
            swal('Uspešno','Uspešno obrisano obaveštenje', 'success')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function isLink(text) {
    return (text.includes('http') || text.includes('www')) && !text.includes('<-dugme->')
}

function isSimpleText(text) {
    return !text.includes('http') && !text.includes('www') && !text.includes('<-dugme->')
}

function isButton(text) {
    return text.includes('<-dugme->')
}

function onButtonClicked(text) {
    let temp = text.split('<-dugme->')[1]
    window.open(temp, "_blank");
}

function getButtonText(text) {
    return text.split('<-dugme->')[0]
}

function openTerms(){
    this.$router.push('/terms');
}

function moreInfo() {
    swal({
        title: 'Polar pulsmetar',
        html: "<b>Prednost praćenja vaših rezultata u realnom vremenu: </b>" +
            "<div>Uvid u tvoj puls omogućava ti da pratiš intezitet treninga kao i tvoj učinak na istom iz dana u dan.<br>" +
            "Praćenje srčanih frekvencija i zone u kojoj se nalaziš tokom treninga može da te motiviše da povećaš intezitet vežbanja ili da te upozori da ga smanjiš.<br></div>",

        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Dalje',
        confirmButtonColor: '#1b1e24',
        cancelButtonColor: '#1b1e24',
        confirmButtonText: 'Nazad',
        customClass: 'swal2-warning'
    }).then(function () {

    }).catch(function () {
        swal({
            title: 'Polar pulsmetar',
            html: "<div><b>Polar pulsmetar</b> je jedan od najpreciznijih pokazatelja utrošenih kalorija tokom treninga.</div>" +
                "<div><br></div>"+
                "<div><b>Polar pulsmetar</b> se nosi tokom treninga i daje vam podatke o pulsu, potrošenim kalorijama i zoni u kojoj se nalazite.</div>",
            type: 'info',
            showCancelButton: false,
            cancelButtonText: 'Dalje',
            confirmButtonColor: '#1b1e24',
            cancelButtonColor: '#1b1e24',
            confirmButtonText: 'Zatvori',
            customClass: 'swal2-warning'
        }).then(function () {

        }).catch(function () {

        });
    });
}

function contact() {
    swal({
        title: 'Kontakt',
        html: "<div><b>Telefon:</b><br> <a href='tel:+381621922105'>+381621922105</a></div><br>" +
            "<div><b>Email:</b><br><a href='mailto:gaainzfactory@gmail.com'>gaainzfactory@gmail.com</a></div>",
        type: 'info',
        showCancelButton: false,
        cancelButtonText: 'Dalje',
        confirmButtonColor: '#1b1e24',
        cancelButtonColor: '#1b1e24',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    }).catch(function () {

    });
}

function reserve() {
    if(session.getAccessToken() === null || session.getAccessToken() === ''){
        this.$router.push('/login');
    }else{
        this.$router.push('/trainings');
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/Home.js